import React, { useEffect } from 'react';

import { toISOFormat } from 'helpers/helpers';
import {
    operations,
    DynamicFilterOperations as DFO,
} from 'business/definitions';
import { EXTRACT_OPERATION } from 'business/constants';
import DateOperationSelector from './DateManagees/DateOperationSelector/DateOperationSelector';
import { getDateFilterManager } from 'components/Shared/filters/helpers';

type Props = {
    filter: SentenceFilterT;
    setFilter: FlowAnyFunction;
    displayIndex: number;
    isPerimeterFilter: boolean;
    shouldDebounce: boolean;
    isDisabled: boolean;
};

const availableOperations = operations.date
    .concat(Object.values(DFO))
    .concat(EXTRACT_OPERATION);

const DateFilterManager = ({
    filter,
    setFilter,
    displayIndex,
    isPerimeterFilter,
    isDisabled,
    shouldDebounce,
}: Props): React.ReactElement => {
    const DateFilterPickerItem = getDateFilterManager(
        filter.operation,
        filter.value,
    );

    /* Populate default value on construct */
    useEffect(() => {
        const shouldResetValue = !isPerimeterFilter && !filter.value;
        if (shouldResetValue) setFilter({ value: toISOFormat(new Date()) });
    }, []);

    /* Reset default filter on filter type change */
    useEffect(() => {
        if (!availableOperations.includes(filter.operation)) {
            setFilter({ operation: DFO.last, value: '1', valueScale: 'year' });
        }
    }, [filter.operation, setFilter]);

    if (!availableOperations.includes(filter.operation)) {
        return <></>;
    }
    return (
        <DateFilterPickerItem
            isPerimeterFilter={isPerimeterFilter}
            filter={filter}
            setFilter={setFilter}
            isDisabled={isDisabled}
            shouldDebounce={shouldDebounce}
        >
            <DateOperationSelector
                key={filter.field}
                className="e2e-filter-operation no-flex-shrink filter-operation"
                isPerimeterFilter={isPerimeterFilter}
                isDisabled={isDisabled}
                // @ts-expect-error is it used by the component?
                displayIndex={displayIndex}
                fullWidth={false}
                value={filter.value ? filter.value : ''}
                field={filter.field}
                valueScale={filter.valueScale}
                operation={filter.operation}
                setFilter={setFilter}
            />
        </DateFilterPickerItem>
    );
};

export default DateFilterManager;
